import {ArticleResponse, ArticleUpdateReq} from './article.contracts';

export class DisplayResponse extends ArticleResponse {
    public color!: string;
    public diagonal!: number;
    public imageFormat!: string;
    public resolution!: string;
    public refreshRate!: number;
    public responseTime!: number;
    public contrast!: string;
    public brightness!: number;
    public shape!: string;
    public panel!: string;
    public viewingAngle!: string;
    public powerConsumption!: number;

    public override clone(response: DisplayResponse): DisplayResponse {
        let responseClone = new DisplayResponse();

        responseClone.color = response.color;
        responseClone.diagonal = response.diagonal;
        responseClone.imageFormat = response.imageFormat;
        responseClone.resolution = response.resolution;
        responseClone.refreshRate = response.refreshRate;
        responseClone.responseTime = response.responseTime;
        responseClone.contrast = response.contrast;
        responseClone.brightness = response.brightness;
        responseClone.shape = response.shape;
        responseClone.panel = response.panel;
        responseClone.viewingAngle = response.viewingAngle;
        responseClone.powerConsumption = response.powerConsumption;

        return responseClone;
    }
}

export class DisplayRequest extends ArticleUpdateReq {
    public color?: string;
    public diagonal?: number;
    public imageFormat?: string;
    public resolution?: string;
    public refreshRate?: number;
    public responseTime?: number;
    public contrast?: string;
    public brightness?: number;
    public shape?: string;
    public panel?: string;
    public viewingAngle?: string;
    public powerConsumption?: number;

    public override fromResponse(response: DisplayResponse): DisplayRequest {
        let request = new DisplayRequest();

        request.color = response.color;
        request.diagonal = response.diagonal;
        request.imageFormat = response.imageFormat;
        request.resolution = response.resolution;
        request.refreshRate = response.refreshRate;
        request.responseTime = response.responseTime;
        request.contrast = response.contrast;
        request.brightness = response.brightness;
        request.shape = response.shape;
        request.panel = response.panel;
        request.viewingAngle = response.viewingAngle;
        request.powerConsumption = response.powerConsumption;

        return request;
    }
}

export class DisplayCsvImportRequest {
    mappingId!: number;
    data!: any[];

    constructor(mappingId: number, data: any[]) {
        this.mappingId = mappingId;
        this.data = data;
    }
}
